import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Message } from '@design-system-coopeuch/web';

import { casoBordeActions } from '../../../../application/actions/casoBordes';
import { properties } from '../../../../utils/properties';
import TagManagerUtils from '../../../../utils/TagManagerUtils';

import errorUsuario from '../../../assets/img/icon/User-Error.svg';
import { WrapperCasosBordes } from './styles';


const CasosBorderThemplateListaNegra = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(casoBordeActions.casoBordeEstado(true));
    TagManagerUtils.triggerEventMetodo(
      "trigger_event",
      "",
      "/verificacion",
      "Error",
      "No cumple las condicione",
    );
  },[])

  const paginaBeneficios = () => {
    window.location.href = properties.urlBeneficios;
  };

  const volveraCoopeuch = () => {
    window.location.href = properties.urlHomeCoopeuch;
  };

  return (
    <WrapperCasosBordes>
      <h1>{properties.casosBordes.ListaNegra.titulo}</h1>
      <img src={errorUsuario} alt="error usuario" />
      <h2>{properties.casosBordes.ListaNegra.bajada}</h2>
      <p>{properties.casosBordes.ListaNegra.bajada}</p>
      <Button variant='text' onClick={paginaBeneficios}>{properties.casosBordes.ListaNegra.textoBoton}</Button>
      <div className="mensaje-contenedor">
        <Message
          description="Llámanos al 600 200 1200"
          title="Consultas al Contact Center"
          type="info"
        />
      </div>
      <div className="verificar">
        <Button variant='text' onClick={volveraCoopeuch} disabled={false}>{properties.casosBordes.ListaNegra.textoBotonDos}</Button>
      </div>
    </WrapperCasosBordes>
  )
}

export default CasosBorderThemplateListaNegra;